__turbopack_context__.v({
  "section": "CompanyDescription-module-scss-module__aJwg8W__section",
  "text": "CompanyDescription-module-scss-module__aJwg8W__text",
});
